import Items from '../components/item'
import Loading from 'vue-loading-overlay'
import Message from '../components/message'

export default {
  Items,
  Loading,
  Message
}



// WEBPACK FOOTER //
// ./src/app/dweller/book-occurrence/index/resources/components.js